import { useEffect, useState } from 'react';

import { VersionReviewDialog } from '../../../components/VersionReviewDialog/index.js';
import type { EvaluationTemplateVersion } from '../../../types/evaluationTemplate.js';
import {
  EvaluationTemplateForm,
  type EvaluationTemplateWithConfig,
} from '../EvaluationTemplateForm/EvaluationTemplateForm.js';

export interface TemplateVersionSnapshotDialogProps {
  version: EvaluationTemplateVersion | null;
  onClose: () => void;
}

export function TemplateVersionSnapshotDialog({
  version,
  onClose,
}: TemplateVersionSnapshotDialogProps) {
  const [shown, setShown] = useState<EvaluationTemplateVersion | null>(version);
  useEffect(() => {
    if (version !== null) setShown(version);
  }, [version]);

  return (
    <VersionReviewDialog
      open={version !== null}
      title={
        shown ? `${shown.name} — version ${String(shown.version)}` : 'Version'
      }
      onClose={onClose}
    >
      {shown && (
        <EvaluationTemplateForm
          mode="view"
          initialTemplate={shown as unknown as EvaluationTemplateWithConfig}
        />
      )}
    </VersionReviewDialog>
  );
}
